/**
 * What the list hands the card through the router state (no API): the ids of the rows it shows,
 * in its order, for ‹ ›; and the list's own address with its filters, for «Note spese».
 */
export type CardNavigation = {
  readonly ids: readonly string[];
  readonly from: string;
};

/** The router state, if it is one the list wrote; anything else (a typed address, a reload) is none. */
export function readCardNavigation(state: unknown): CardNavigation | null {
  if (typeof state !== 'object' || state === null) return null;
  const { ids, from } = state as Record<string, unknown>;
  if (!Array.isArray(ids) || !ids.every((id) => typeof id === 'string')) return null;
  return {
    ids,
    from: typeof from === 'string' && from.startsWith('/expenses') ? from : '/expenses',
  };
}

/** The neighbours of `id` in the list's order; null at the ends or when the id is not there. */
export function neighbours(
  navigation: CardNavigation | null,
  id: string,
): { previous: string | null; next: string | null } | null {
  if (navigation === null) return null;
  const at = navigation.ids.indexOf(id);
  if (at === -1) return null;
  return {
    previous: at > 0 ? navigation.ids[at - 1]! : null,
    next: at < navigation.ids.length - 1 ? navigation.ids[at + 1]! : null,
  };
}
